module.exports = __webpack_public_path__ + "static/media/horvik.e4fef93f.jpeg";